'use strict';

module.exports = {
  DISPLAY_FORMAT: 'DD MMM YYYY',
  ISO_FORMAT: 'YYYY-MM-DD',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',

  DAY_SIZE: 35,
  BLOCKED_MODIFIER: 'blocked'
};


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRangePickerWrapper/date-picker-constants.js
// module id = 1984
// module chunks = 1